var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#000"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M7 9.5v10.494h2.002V9.5h2v10.493H13V9.5h2v10.493h2V9.5h2V22H5V9.5h2zM15.486 2v3H21v2H3V5h5.5V2h6.986zm-2 2H10.5v1h2.986V4z","transform":"translate(-1262 -320) translate(130 160) translate(600 144) translate(532 16)"})))))));
}

Trash.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Trash;

Trash.default = Trash;
